import React, { memo } from "react";
import { LenderLoanTypeList } from "constants/loanTypes";
import "./styles.css";

// TODO: Bring in loan types from DB that will be used for calculations. Might need to create a migration to add a new column to flag for this.

const LoanTypeLinkList = ({ selectedLoanType, setSelectedLoanType }) => (
  <div className="loan-type-link-list-wrapper">
    {LenderLoanTypeList.map(({ label, value }) => <div
      className={`loan-type-link ${selectedLoanType === value ? "selected-loan-type-link" : ""}`}
      onClick={() => setSelectedLoanType(value)}
      key={label}
    >
      {label}
    </div>)}
  </div>
);

export default memo(LoanTypeLinkList);
